import { render } from "./MathAnswerWidgetLoader.vue?vue&type=template&id=29df484d&ts=true"
import script from "./MathAnswerWidgetLoader.vue?vue&type=script&lang=ts"
export * from "./MathAnswerWidgetLoader.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__